var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.videoUrl)?_c('a',{staticClass:"display-flex flex-row text-decoration-none flex-align-center",attrs:{"target":"_blank","href":_vm.videoUrl}},[_c('h3',{staticClass:"bold mr-1"},[_vm._v("Watch video")]),_c('AppIcon',{attrs:{"width":23,"height":17,"name":"play-connection-tutorial"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }